import {forwardRef} from "react";
import {iconStyles} from "./icon.css";
import uiClasses from "@cdx/common/xui/ui.css";
import {cx} from "@cdx/common";

import {ReactComponent as FacebookSvg} from "../assets/facebook.svg";
import {ReactComponent as InstagramSvg} from "../assets/instagram.svg";
import {ReactComponent as LinkedinSvg} from "../assets/linkedin.svg";
import {ReactComponent as WhatsappSvg} from "../assets/whatsapp.svg";

const makeComponent = (SvgComp, fallbackAlt) =>
  forwardRef(({className, size = "md", color, alt}, ref) => (
    <div
      ref={ref}
      className={cx(
        iconStyles.container.base,
        iconStyles.container.bySize[size],
        color && uiClasses.color[color],
        className
      )}
    >
      <SvgComp alt={alt || fallbackAlt} />
    </div>
  ));

export const IconFacebook = makeComponent(FacebookSvg, "Facebook");
export const IconInstagram = makeComponent(InstagramSvg, "Instagram");
export const IconLinkedin = makeComponent(LinkedinSvg, "Linkedin");
export const IconWhatsapp = makeComponent(WhatsappSvg, "Whatsapp");
